import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getWhiteMailExcel (data = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getClientTemplate)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/empresas/descargarlistablancaemails',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      responseType: 'blob',
      data,
    }
    const res = await axiosInstance(req)
    const response = {
      data: res.data,
      headers: res.headers
    }
    return response
  }
}

export { getWhiteMailExcel }
